class BbdSizeGuideAside extends HTMLElement {
  #isLoaded = false;
  #isLoading = false;

  constructor() {
    super();

    this.elements = {
      modal: this.querySelector('.bbd-size-guide-aside__modal'),
      closeButton: this.querySelector('.bbd-size-guide-aside__close'),
      content: this.querySelector('.bbd-size-guide-aside__content'),
      openButton: document.querySelector('.bbd-sizing-chart-trigger')
    };

    this.#initEvents();
  }

  #initEvents() {
    if (!this.elements.openButton || !this.elements.closeButton || !this.elements.modal) return;

    this.elements.openButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.#openDrawer();
    });

    this.elements.closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.#closeDrawer();
    });

    this.elements.modal.addEventListener('click', (e) => {
      if (e.target === this.elements.modal) this.#closeDrawer();
    });

    this.elements.modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#closeDrawer();
    });
  }

  async #openDrawer() {
    if (typeof this.elements.modal.showModal !== 'function') return;

    this.elements.modal.showModal();
    document.body.classList.add('no-scroll');

    if (!this.#isLoaded && !this.#isLoading) {
      this.#isLoading = true;
      await this.#loadContent();
      this.#isLoading = false;
    }
  }

  #closeDrawer() {
    if (typeof this.elements.modal.close !== 'function') return;

    this.elements.modal.close();
    document.body.classList.remove('no-scroll');
  }

  async #loadContent() {
    const pageUrl = this.dataset.pageUrl;
    if (!pageUrl) return;

    try {
      const response = await fetch(pageUrl);
      if (!response.ok) return;

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const main = html.querySelector('#MainContent');

      if (main) {
        this.#isLoaded = true;
        this.#injectHeadStyles(html);
        this.elements.content.innerHTML = main.innerHTML;
        this.#runInlineScripts(this.elements.content);
      }
    } catch {
      // silently fail — content area stays empty
    }
  }

  #injectHeadStyles(parsedDoc) {
    for (const style of parsedDoc.querySelectorAll('head style')) {
      document.head.appendChild(style.cloneNode(true));
    }
  }

  #runInlineScripts(container) {
    for (const oldScript of container.querySelectorAll('script')) {
      if (oldScript.src) continue;

      const newScript = document.createElement('script');
      for (const attr of oldScript.attributes) {
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    }
  }
}

if (!customElements.get('bbd-size-guide-aside')) {
  customElements.define('bbd-size-guide-aside', BbdSizeGuideAside);
}
